import { Dispatch } from "redux"
import Konva from "konva"

import { PENDING } from "const"
import {
    LifecyclePhase,
    LifecycleConnection,
} from "server/models"
import {
    UpdateLifecyclePhasePosition,

    setLifecycleModelDragPhase,
    setLifecycleModelLoadState,
    setLifecycleModelReload,

    setLifecycleConnectionList,
} from "client/store"

import { gridSize } from "../const"
import { PhaseGui } from "./phaseGui"
import {
    CalculateConnectionPoints,
    UpdateConnectionPoints,
} from "./connectionPoints"
import GetRelativePosition from "./getPosition"

export const DragMovePhase = (
    dataWrapper: Konva.Layer,
    dragPhase: Konva.Node,
    phase: LifecyclePhase,
    gui: PhaseGui,
    connectionList: readonly LifecycleConnection[],
    dispatch: Dispatch,
) => {
    // snap phase to the grid
    const mousePos = GetRelativePosition(dataWrapper)
    const phasePos = GetRelativePosition(dataWrapper, dragPhase)

    const diffPos = {
        x: mousePos.x - phasePos.x,
        y: mousePos.y - phasePos.y,
    }
    const newPos = {
        x: mousePos.x - diffPos.x,
        y: mousePos.y - diffPos.y,
    }
    const gridPosition = {
        x: Math.floor(newPos.x / gridSize) * gridSize,
        y: Math.floor(newPos.y / gridSize) * gridSize,
    }

    dragPhase.position(gridPosition)

    const newConnectionList = CalculateConnectionPoints(phase.id, gridPosition, gui, connectionList)
    dispatch(setLifecycleConnectionList(newConnectionList))
}

export const DragEndPhase = (
    dragPhase: Konva.Node,
    phase: LifecyclePhase,
    dispatch: Dispatch,
) => {
    dispatch(setLifecycleModelLoadState(PENDING))
    const position = dragPhase.position()

    Promise.all([
        UpdateLifecyclePhasePosition(phase.id, position),
        UpdateConnectionPoints(phase.id, phase.name, position),
    ]).then(() => {
        dispatch(setLifecycleModelDragPhase(null))

        dispatch(setLifecycleModelReload(false))
        setTimeout(() => {
            dispatch(setLifecycleModelReload(true))
        }, 0)
    })
}
